import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      hasHE: false,
    };
  },
  methods: {
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorization',
      'getUserLoginDetails',
      'storeLoginInfo',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
      'setFirstTimeEntry',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
    ]),
    getNextVerificationStep() {
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName:
        return () => {
          if (this.hasHE && this.isSingleOptIn()) {
            this.$axios.get(`api/heRegister?msisdn=${this.user.msisdn}&hash=${encodeURIComponent(this.user.hash)}&lang=${this.getLocale}&cid=${this.getCorrelationId}`).then((response) => {
              if (response.data.responseEnum === 'OPERATION_SUCCESS') {
                this.storeLoginInfo({
                  token: response.data.data.user_auth_token,
                  rememberMeParameter: true,
                  username: response.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            });
          } else {
            this.standardRequestPinProcess();
          }
        };
      default:
        return this.standardRequestPinProcess();
      }
    },
    standardRequestPinProcess() {
      this.message = '';
      this.waitForResponse = true;
      this.$axios.get(`api/requestPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.operatorPicked}`).then((response) => {
        const resp = response.data.responseEnum;
        if (resp === 'OPERATION_SUCCESS') {
          this.user.msisdn = '';
          this.setRegistrationInfo(response.data.data);
          this.storeOperator(this.operatorPicked);
          if (this.operatorPicked) {
            this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${this.operatorPicked}`).then((res) => {
              this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
              this.setDisplayPrice({ value: res.data.data.displayPrice });
              this.$router.push('register2');
              this.waitForResponse = false;
            });
          } else {
            this.$router.push('register2');
            this.waitForResponse = false;
          }
        } else {
          // eslint-disable-next-line
          if (this.operatorPicked) {
            this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${this.operatorPicked}`).then((res) => {
              this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
              this.mapErrorMessages(resp);
              this.hasErrors = true;
            });
          } else {
            this.mapErrorMessages(resp);
            this.hasErrors = true;
          }
          this.waitForResponse = false;
        }
      });
    },
    authorizationProcess() {
      const userData = {
        username: this.registrationInfoMsisdn,
        password: this.user.pin,
        rememberMe: true,
        freePlayPoints: this.freeTrialUserPrice,
        cid: this.getCorrelationId,
        fbReferral: this.fbReferral,
        clickId: this.getClickId,
        refUrl: this.getRefUrl,
        campaignId: this.getCampaignId,
        publisherId: this.getPublisherId,
      };
      this.callForAuthorization(userData).then(() => {
        if (this.getUserAuthorized) {
          this.$gtm.trackEvent({
            event: 'CompleteRegistration',
            category: 'MSISDN Registration',
            action: 'Register 2 registration',
            label: 'Register 2',
          });
          this.getUserLoginDetails().then(() => {
            this.setFirstTimeEntry(true);
            this.updateUserLanguage();
            this.$router.push('home');
            this.waitForResponse = false;
          });
        } else {
          this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
          this.waitForResponse = false;
        }
      });
    },
    getNextRegistrationStep() {
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName: return () => {
        this.authorizationProcess();
      };
      case this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName: return () => {
        // eslint-disable-next-line
        console.log('SIMPLIFY_REGISTRATION_WITHOUT_WEB_REG case');
      };
      default: return () => {
        this.$axios.get(`api/verifyPin?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}`).then((response) => {
          const resp = response.data.responseEnum;
          this.waitForResponse = false;
          if (resp === 'OPERATION_SUCCESS') {
            const subscribedViaWeb = response.data.data.subscribedViaWeb;
            if (subscribedViaWeb) {
              if (this.multiOperatorInfo.multiOperatorEnabled) {
                if (this.multiOperatorInfo.operatorPicked.includes('DU')) {
                  this.$gtm.trackEvent({
                    event: 'CompleteRegistrationDU',
                    category: 'MSISDN Registration',
                    action: 'Register 2 registration',
                    label: 'Register 2',
                  });
                } else {
                  this.sendCompleteRegistrationEvent();
                }
              } else {
                this.sendCompleteRegistrationEvent();
              }
            }
            this.$router.push('register3');
          } else {
            this.showErrorMessage(resp);
          }
        });
      };
      }
    },
    showErrorMessage(resp) {
      if (resp === 'PIN_EXPIRED') {
        this.message = 'visitor_sign_up_2_pin_expired';
      } else if (resp === 'WRONG_PIN') {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
      } else if (resp === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resp === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
        this.message = 'registration_process_with_test_msisdn_perfomed';
      }
      this.hasErrors = true;
    },
    sendCompleteRegistrationEvent() {
      this.$gtm.trackEvent({
        event: 'CompleteRegistration',
        category: 'MSISDN Registration',
        action: 'Register 2 registration',
        label: 'Register 2',
      });
    },
    getNextForgotPasswordStep() {
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName: return () => { this.$router.push('login'); };
      case this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName: return () => { this.$router.push('login'); };
      default: return () => { this.$router.push('forgotPassword2'); };
      }
    },
    isSingleOptIn() {
      return this.hasSingleOptIn;
    },
    show2stepsOnlyOrNoneInForgot() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName;
    },
    showStepsWithoutWebInForgot() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName;
    },
    hasSimplify() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName;
    },
    hasWebRegister() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.DEFAULT.propertyName;
    },
    isString(value) {
      return typeof value === 'string' || value instanceof String;
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialUserPrice',
      'oneTimeSubscriptionBundleId',
      'defaultDailySubButtonEnabled',
      'multiOperatorInfo',
      'simpleRegistration',
      'availableFlows',
      'fbReferral',
      'hasSingleOptIn',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getClickId',
      'getRefUrl',
      'getCampaignId',
      'getPublisherId',
      'getCorrelationId',
    ]),
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/flow.js